import React, { useState, useRef, useEffect } from "react";
import RecordRTC from "recordrtc";
import logoainxt from '../component/asset/ainxt_logo-removebg-preview.png';
import logonuvama from '../component/asset/Nuvama_logo-removebg-preview.png';
import logoblinkx from '../component/asset/blinkx-logo.png';
import logoventura from '../component/asset/ventura-logo.png';
import logoinstakyc from '../component/asset/insta-kyc.png';
import logomo from '../component/asset/mo-logo.png';
import logoanadrathi from '../component/asset/anandrathi.png';
import logophillipcapital from '../component/asset/phillipcapital.png'
import logosharekhan from '../component/asset/sharekhan.svg'
import './VideoRecorder.css';
import { FaPlay } from "react-icons/fa"; // (unused now, safe to remove)
import { FaPause } from "react-icons/fa6"; // (unused now, safe to remove)
import { v4 as uuidv4 } from 'uuid';
import { ReactComponent as MyIcon } from '../undraw_selected-box_qnrz.svg';
import arrow from '../curved-arrow.png';
import declarationTextFallback from "./declarationText";
import uuid from 'uuid-random';
import toast, { Toaster } from "react-hot-toast";
import api from "./apiconfig";
// import { applogo1, authorized1 } from './config';

const VideoComponent = ({ setSuccess, paramsObj, applogo, authorized }) => {
    // UI flow states
    const [uniqueId, setUniqueId] = useState(uuidv4());
    const [isLoading, setIsLoading] = useState(false);
    const [isCountingDown, setIsCountingDown] = useState(false);
    const [countdown, setCountdown] = useState(3);
    const [isRecording, setIsRecording] = useState(false);
    const [faceSnapshotBase64, setFaceSnapshotBase64] = useState("");
    const [illustrations, setIllustrations] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [faceDetected, setFaceDetected] = useState(false);
    const [faceOutofCircle, setFaceOutofCircle] = useState(0);
    const [language, setLanguage] = useState("en");
    const [videoLoaded, setVideoLoaded] = useState(false);
    const [location, setLocation] = useState({ lat: null, long: null });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    const [recordTime, setRecordTime] = useState(0);
    const maxRecordTime = 10;

    // API + transcript
    const [apiTranscript, setApiTranscript] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [isApiLoading, setIsApiLoading] = useState(false);
    const [apiDisableScript, setApiDisableScript] = useState(false);
    const [transScriptStatus, setTransScriptStatus] = useState(false);
    const [isIos, setIsIos] = useState(false)
    // Fallback
    const [isFallback, setIsFallback] = useState(false);

    // Refs
    const videoRef = useRef(null);
    const streamRef = useRef(null);
    const recorderRef = useRef(null);

    const faceSnapshotBase64Ref = useRef("");
    const detectIntervalRef = useRef(null);
    const detectIntervalCondition = useRef(false);
    const setFalseDetection = useRef(false);
    const setFarDetection = useRef(false);
    const isAbortedByFaceDetectionRef = useRef(false);
    let cascade = () => -1;
    let detectionMemory;

    const [ipAddress, setIpAddress] = useState("");
    const [params, setParams] = useState([]);
    const [isVideoComponentVisible, setIsVideoComponentVisible] = useState(true);
    // NEW: we keep the recorded blob, do NOT create an object URL or play it
    const [recordedBlob, setRecordedBlob] = useState(null);

    // (Playback states are unused now; safe to remove if you like)
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [recordedUrl, setRecordedUrl] = useState("");

    useEffect(() => {
        if (!recordedBlob) {
            setRecordedUrl("");
            return;
        }
        const url = URL.createObjectURL(recordedBlob);
        setRecordedUrl(url);
        return () => {
            URL.revokeObjectURL(url);
        };
    }, [recordedBlob]);

    const playbackRef = useRef(null);
    const [isRecordedPlaying, setIsRecordedPlaying] = useState(false);
    const [recordedCurrentTime, setRecordedCurrentTime] = useState(0);
    const [recordedDuration, setRecordedDuration] = useState(0);

    const onRecordedLoaded = () => {
        const v = playbackRef.current;
        if (!v) return;
        setRecordedDuration(v.duration || 0);
        setRecordedCurrentTime(v.currentTime || 0);
    };
    const onRecordedTimeUpdate = () => {
        const v = playbackRef.current;
        if (!v) return;
        setRecordedCurrentTime(v.currentTime);
    };
    const handleRecordedPlayPause = () => {
        const v = playbackRef.current;
        if (!v) return;
        if (v.paused) v.play();
        else v.pause();
    };

    const seekRecorded = (seconds) => {
        const v = playbackRef.current;
        if (!v || !v.duration) return;
        v.currentTime = Math.min(Math.max(0, (v.currentTime || 0) + seconds), v.duration);
    };
    const handleRecordedSeekChange = (e) => {
        const v = playbackRef.current;
        if (!v) return;
        v.currentTime = Number(e.target.value);
    };

    useEffect(() => {
        faceSnapshotBase64Ref.current = faceSnapshotBase64;
    }, [faceSnapshotBase64]);

    useEffect(() => {
        if (faceOutofCircle >= 120 && detectIntervalRef.current) {
            if (isRecording) {
                isAbortedByFaceDetectionRef.current = true;
                stopRecording();
                setRecordedBlob(null);
                setRecordedUrl("");
                // Only clear interval and other resources if we were already recording to "lock" the error screen
                clearInterval(detectIntervalRef.current);
                detectIntervalRef.current = null;
                videoRef.current = null;
                recorderRef.current = null;
                streamRef.current = null;
            }
            // If not recording (e.g. alignment phase), do NOT clear the interval. 
            // The warning screen will show because faceOutofCircle >= 120, 
            // but the detection still runs and can reset faceOutofCircle to 0 if the user re-centers.
        }
    }, [faceOutofCircle]);

    const formatTime = (sec) => (sec < 10 ? `0${sec}` : sec);

    // On mount
    useEffect(() => {

        let ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        setIsIos(ios);
        const searchParams = new URLSearchParams(window.location.search);
        const paramsObj = {};
        for (let [key, value] of searchParams.entries()) {
            paramsObj[key] = value;
        }
        setParams(paramsObj);

        fetch("https://api.ipify.org?format=json")
            .then(res => res.json())
            .then(data => setIpAddress(data.ip))
            .catch(err => console.error("Error fetching IP address:", err));

        if (
            typeof MediaRecorder === "undefined" ||
            !MediaRecorder.isTypeSupported("video/webm; codecs=vp8,opus")
        ) {
            console.warn("Native MediaRecorder not supported; using RecordRTC fallback.");
            setIsFallback(true);
        }
        captureGeo();

        return () => {
            if (detectIntervalRef.current) clearInterval(detectIntervalRef.current);
            if (videoRef.current && videoRef.current.srcObject) {
                const tracks = videoRef.current.srcObject.getTracks();
                tracks.forEach(track => track.stop());
            }
        };
    }, []);

    const captureGeo = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        lat: position.coords.latitude,
                        long: position.coords.longitude,
                    });
                },
                (error) => {
                    console.error("Error fetching location:", error);
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    };

    // Send AUDIO (currently not used; you can remove if not needed)
    // const sendAudioToApi = (blob) => {
    //     let paramsCntId = params['cntid'] || 'test1';
    //     let paramsKycId = params['kycid'] || 'test1';
    //     let paramsReqId = params['reqid'] || 'ainxt123';

    //     clearInterval(detectIntervalRef.current);
    //     detectIntervalRef.current = null;
    //     const snapshot = faceSnapshotBase64Ref.current;

    //     setIsApiLoading(true);
    //     const reader = new FileReader();
    //     reader.onloadend = () => {
    //         const base64data = reader.result.split(",")[1];

    //         const myHeaders = new Headers();
    //         myHeaders.append("x-api-key", "dgHnYHpcBxajmdmlWymPO40PVFzaTkvq75hHHj5m");
    //         myHeaders.append("Content-Type", "application/json");
    //         myHeaders.append("authorizationToken", "M716Cq1I2qDUTh1z");

    //         const raw = JSON.stringify({
    //             media: base64data,
    //             facebyte: snapshot,
    //             language: language,
    //             device: /iPad|iPhone|iPod/i.test(navigator.userAgent) ? "ios" : "android",
    //             latitude: location.lat,
    //             longitude: location.long,
    //             requestid: paramsReqId,
    //             clientid: paramsCntId,
    //             kycid: paramsKycId,
    //             ipaddress: ipAddress
    //         });

    //         const requestOptions = { method: "POST", headers: myHeaders, body: raw, redirect: "follow" };

    //         fetch("https://ainxt.nomineeoptout.uat.ainxtkyc.com/verify_nominee_optout", requestOptions)
    //             .then((res) => res.json())
    //             .then((data) => {
    //                 if (data.result === true) {
    //                     setApiTranscript(data.remark || declarationText[language][7]);
    //                     setTransScriptStatus(true);
    //                     window.parent.postMessage(data, "*");
    //                     setSuccess(true);
    //                 } else {
    //                     setApiTranscript(data.remark || declarationText[language][7]);
    //                     setTransScriptStatus(false);
    //                 }
    //                 setIsApiLoading(false);
    //             })
    //             .catch((error) => {
    //                 console.error("Error sending audio:", error);
    //                 setIsApiLoading(false);
    //             });
    //     };
    //     reader.readAsDataURL(blob);
    // };

    // Send VIDEO

    const sendVideoToApi = (blob) => {
        let uniqueRequestId = uuid();
        console.log("Generated unique request ID:", uniqueRequestId);

        let paramsCntId = params['cntid'] || 'test1';
        let paramsKycId = params['kycid'] || 'test1';
        let paramsReqId = params['reqid'] || 'ainxt123';
        const snapshot = faceSnapshotBase64Ref.current;

        if (detectIntervalRef.current) {
            clearInterval(detectIntervalRef.current);
            detectIntervalRef.current = null;
        }
        setIsApiLoading(true);

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64data = reader.result.split(",")[1];

            const myHeaders = new Headers();
            myHeaders.append("x-api-key", api.x_api_key);
            myHeaders.append("authorizationToken", api.authorizationToken);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                media: base64data,
                facebyte: snapshot,
                language: language,
                device: "web",
                latitude: location.lat,
                longitude: location.long,
                requestid: uniqueRequestId,
                clientid: paramsCntId,
                kycid: paramsKycId,
                ipaddress: ipAddress
            });

            // console.log("Sending video data to API:", raw);


            const requestOptions = { method: "POST", headers: myHeaders, body: raw, redirect: "follow" };

            fetch(api.verify_nominee_optout, requestOptions)
                .then((res) => res.json())
                .then((data) => {
                    if (data.result === true) {
                        setApiTranscript(data.remark || declarationTextFallback.retakeMessage[language]);
                        setTransScriptStatus(true);

                        window.parent.postMessage(data, "*");
                        setSubmitSuccess(true)
                        // setSuccess(true);
                    } else {
                        setIsVideoComponentVisible(false);
                        setApiTranscript(data.remark || declarationTextFallback.retakeMessage[language]);
                        setTransScriptStatus(false);
                    }
                    setIsApiLoading(false);
                })
                .catch((error) => {
                    console.error("Error sending video:", error);
                    setIsApiLoading(false);
                });
        };
        reader.readAsDataURL(blob);
    };

    const handleCaptureClick = async () => {
        setIllustrations(false);
        isAbortedByFaceDetectionRef.current = false;

        if (!isRecording && !isCountingDown && !recordedBlob) {
            setIsLoading(true);
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: true,
                    audio: true,
                });
                streamRef.current = stream;

                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    videoRef.current.muted = true;
                    videoRef.current.play();
                    loadModal();
                    const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
                    if (isIOS) {
                        videoRef.current.setAttribute('playsinline', 'true');
                        videoRef.current.setAttribute('controls', 'true'); // controls visible during preview if needed
                    }
                }
                setIsLoading(false);
                setCountdown(3);
                setIsCountingDown(true);

                // Simulate face detection (if you keep it)
                setTimeout(() => setFaceDetected(true), 1000);
            } catch (error) {
                if (error.name === "NotReadableError") {
                    alert("Camera is already being used in another tab.");
                } else {
                    alert("Unable to access camera: " + error.message);
                }
                console.error("Error accessing camera:", error);
                setIsLoading(false);
                if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
                    alert('Camera and microphone permissions are required to record the video.');
                }
            }
        } else if (isRecording) {
            stopRecording();
        }
    };

    const setupInterval = () => {
        const canvas = document.createElement("canvas");
        const video = videoRef.current;
        if (!canvas || !video) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        if (detectIntervalRef.current) clearInterval(detectIntervalRef.current);
        detectIntervalRef.current = setInterval(() => {
            if (!video || !ctx) return;
            const width = video.videoWidth;
            const height = video.videoHeight;
            if (width === 0 || height === 0) return;

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(video, 0, 0, width, height);
            // const dataURL = canvas.toDataURL("image/png");
            // console.log(dataURL);
            const imageData = ctx.getImageData(0, 0, width, height).data;
            const grayscale = new Uint8Array(width * height);

            for (let y = 0; y < height; y++) {
                for (let x = 0; x < width; x++) {
                    const idx = (y * width + x) * 4;
                    grayscale[y * width + x] = (2 * imageData[idx] + 7 * imageData[idx + 1] + imageData[idx + 2]) / 10;
                }
            }

            const image = { pixels: grayscale, nrows: height, ncols: width, ldim: width };
            const params = { shiftfactor: 0.1, minsize: Math.round(0.25 * width), maxsize: Math.round(0.6 * width), scalefactor: 1.1 };
            let detections = run_cascade(image, cascade, params);
            detections = detectionMemory(detections);
            detections = cluster_detections(detections, 0.2);

            const detectedFaces = [];
            for (let det of detections) {
                // Centering Check: Face must be within 28% of the frame center to be "in the circle"
                // const centerX = width / 2;
                // const centerY = height / 2;
                // const distFromCenter = Math.sqrt(Math.pow(det[1] - centerX, 2) + Math.pow(det[0] - centerY, 2));
                // const maxAllowedDist = width * 0.28;

                if (!(5 > det[3] || det[2] < Math.round(0.20 * width))) {
                    if (det[2] > Math.round(0.5 * width)) setFalseDetection.current = true;
                    else if (detectedFaces.length === 0) detectedFaces.push(det[1]);
                    else {
                        const m = det[1];
                        if (!(0.2 >= Math.abs(1 - detectedFaces[detectedFaces.length - 1] / m))) {
                            detectedFaces.push(m);
                            break;
                        }
                    }
                } else if (det[2] > Math.round(0.35 * width) || det[3] > 5) {
                    setFarDetection.current = true;
                }
            }
            // console.log("Detected faces:", detectedFaces);
            if (detectedFaces.length === 1) {
                // You can add UI hints if needed
                setFaceOutofCircle(0);
                setFalseDetection.current = false;
                setFarDetection.current = false;
            } else {
                setFaceOutofCircle((prev) => prev + 1);
            }
            detectIntervalCondition.current = true;
        }, 16);
    };

    function unpack_cascade(b) {
        var g = new DataView(new ArrayBuffer(4)),
            a = 8;
        g.setUint8(0, b[a + 0]);
        g.setUint8(1, b[a + 1]);
        g.setUint8(2, b[a + 2]);
        g.setUint8(3, b[a + 3]);
        var d = g.getInt32(0, true);
        a += 4;
        g.setUint8(0, b[a + 0]);
        g.setUint8(1, b[a + 1]);
        g.setUint8(2, b[a + 2]);
        g.setUint8(3, b[a + 3]);
        var f = g.getInt32(0, true);
        a += 4;
        var h = [], k = [], l = [];
        for (var m = 0; m < f; ++m) {
            h.push(0, 0, 0, 0);
            h.push(...b.slice(a, a + 4 * Math.pow(2, d) - 4));
            a += 4 * Math.pow(2, d) - 4;
            for (var n = 0; n < Math.pow(2, d); ++n) {
                g.setUint8(0, b[a + 0]);
                g.setUint8(1, b[a + 1]);
                g.setUint8(2, b[a + 2]);
                g.setUint8(3, b[a + 3]);
                k.push(g.getFloat32(0, true));
                a += 4;
            }
            g.setUint8(0, b[a + 0]);
            g.setUint8(1, b[a + 1]);
            g.setUint8(2, b[a + 2]);
            g.setUint8(3, b[a + 3]);
            l.push(g.getFloat32(0, true));
            a += 4;
        }
        var p = new Int8Array(h),
            q = new Float32Array(k),
            r = new Float32Array(l);
        return function (t, u, v, w, y) {
            t *= 256;
            u *= 256;
            for (var z = 0, x = 0, B = Math.pow(2, d) >> 0, A = 0; A < f; ++A) {
                var idx = 1;
                for (var C = 0; C < d; ++C) {
                    var leftIdx = ((t + p[z + 4 * idx + 0] * v) >> 8) * y + ((u + p[z + 4 * idx + 1] * v) >> 8);
                    var rightIdx = ((t + p[z + 4 * idx + 2] * v) >> 8) * y + ((u + p[z + 4 * idx + 3] * v) >> 8);
                    var val = (w[leftIdx] <= w[rightIdx]) ? 1 : 0;
                    idx = 2 * idx + val;
                }
                var qValue = q[B * A + idx - B];
                x += qValue;
                if (x <= r[A]) return -1;
                z += 4 * B;
            }
            return x - r[f - 1];
        };
    }

    function run_cascade(b, g, a) {
        var d = b.pixels, f = b.nrows, h = b.ncols;
        var stride = b.ldim;
        var shift = a.shiftfactor, maxsize = a.maxsize, scalefactor = a.scalefactor;
        var minsize = a.minsize;
        var results = [];
        for (; minsize <= maxsize;) {
            var step = Math.max(shift * minsize, 1) >> 0;
            var offset = (minsize / 2 + 1) >> 0;
            for (var y = offset; y <= f - offset; y += step) {
                for (var x = offset; x <= h - offset; x += step) {
                    var score = g(y, x, minsize, d, stride);
                    if (score > 0) results.push([y, x, minsize, score]);
                }
            }
            minsize *= scalefactor;
        }
        return results;
    }

    function cluster_detections(b, threshold) {
        function overlap(r, t) {
            var u = r[0], v = r[1], w = r[2];
            var y = t[0], z = t[1], x = t[2];
            u = Math.max(0, Math.min(u + w / 2, y + x / 2) - Math.max(u - w / 2, y - x / 2));
            v = Math.max(0, Math.min(v + w / 2, z + x / 2) - Math.max(v - w / 2, z - x / 2));
            return (u * v) / (w * w + x * x - u * v);
        }

        b = b.sort((r, t) => t[3] - r[3]);
        var assigned = Array(b.length).fill(0), result = [];

        for (var i = 0; i < b.length; ++i) {
            if (assigned[i] === 0) {
                var sumY = 0, sumX = 0, sumS = 0, sumScore = 0, count = 0;
                for (var j = i; j < b.length; ++j) {
                    if (overlap(b[i], b[j]) > threshold) {
                        assigned[j] = 1;
                        sumY += b[j][0];
                        sumX += b[j][1];
                        sumS += b[j][2];
                        sumScore += b[j][3];
                        count += 1;
                    }
                }
                result.push([sumY / count, sumX / count, sumS / count, sumScore]);
            }
        }
        return result;
    }

    function instantiate_detection_memory(size) {
        let index = 0;
        const memory = Array.from({ length: size }, () => []);
        return function (dets) {
            memory[index] = dets;
            index = (index + 1) % size;
            return memory.flat();
        };
    }

    const loadModal = () => {
        detectionMemory = instantiate_detection_memory(15);
        fetch("https://facelivelinesssdk.s3.ap-south-1.amazonaws.com/fac")
            .then(res => res.arrayBuffer())
            .then(buffer => {
                const cascadeData = new Int8Array(buffer);
                cascade = unpack_cascade(cascadeData);
                console.log("Cascade loaded.");
                setupInterval();
            });
    };

    // countdown
    useEffect(() => {
        let timer;
        if (isCountingDown && countdown > 0) {
            timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
        } else if (isCountingDown && countdown === 0) {
            setIsCountingDown(false);
            let base64Image = "";
            if (videoRef.current && videoRef.current.videoWidth > 0 && videoRef.current.videoHeight > 0) {
                const canvas = document.createElement("canvas");
                canvas.width = videoRef.current.videoWidth;
                canvas.height = videoRef.current.videoHeight;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
                base64Image = canvas.toDataURL("image/jpeg").split(",")[1];
                setFaceSnapshotBase64(base64Image);
            }

            startRecording();
        }
        return () => clearTimeout(timer);
    }, [isCountingDown, countdown]);


    const startRecording = async () => {
        let isAndriod = /Android/i.test(navigator.userAgent);
        let isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);

        if (isAndriod) {
            videoToblobAndriodFun()
        } else {
            videoToblobFun();
        }
    }

    async function videoToblobAndriodFun() {
        console.log('andriod');

        setRecordTime(0);
        if (streamRef.current) {
            const audioStream = new MediaStream();
            streamRef.current.getTracks().forEach(track => {
                if (track.kind === 'audio') audioStream.addTrack(track);
            });

            if (isFallback) {
                recorderRef.current = RecordRTC(audioStream, {
                    type: "audio",
                    mimeType: "audio/wav",
                    recorderType: RecordRTC.MediaStreamRecorder,
                });
                recorderRef.current.startRecording();
                setIsRecording(true);
            } else {
                // AUDIO
                let audioChunks = [];
                try {
                    const audioRecorder = new MediaRecorder(audioStream, { mimeType: "audio/webm; codecs=opus" });
                    audioRecorder.ondataavailable = (event) => {
                        if (event.data && event.data.size > 0) audioChunks.push(event.data);
                    };
                    audioRecorder.onstop = () => {
                        const audioBlob = new Blob(audioChunks, { type: "audio/webm" });
                        // Optionally sendAudioToApi(audioBlob);
                    };
                    audioRecorder.start();
                    recorderRef.current = audioRecorder;
                } catch (e) {
                    console.error("Audio MediaRecorder initialization failed:", e);
                    setIsFallback(true);
                    startRecording();
                    return;
                }

                // VIDEO
                let videoChunks = [];
                try {
                    const videoRecorder = new MediaRecorder(streamRef.current, { mimeType: "video/webm; codecs=vp8,opus" });
                    videoRecorder.ondataavailable = (event) => {
                        if (event.data && event.data.size > 0) videoChunks.push(event.data);
                    };
                    videoRecorder.onstop = async () => {
                        const videoBlob = new Blob(videoChunks, { type: "video/webm" });
                        // let finalBlob = await maybeRecompressToMax5MB(videoBlob);
                        // IMPORTANT: do NOT create an object URL or assign to <video>
                        if (!isAbortedByFaceDetectionRef.current) {
                            setRecordedBlob(videoBlob);
                        }

                        // stop showing live preview
                        if (videoRef.current) {
                            videoRef.current.pause();
                            videoRef.current.srcObject = null; // clears preview
                            videoRef.current.removeAttribute('src');
                        }

                        // console.log('finalBlob',finalBlob);
                        // alert(`Video size: ${(finalBlob.size / 1024).toFixed(1)} KB`);

                        // send immediately
                        // sendVideoToApi(finalBlob);
                        // sendVideoToApi(videoBlob);
                    };
                    videoRecorder.start();
                    recorderRef.current = videoRecorder;
                    setIsRecording(true);
                } catch (e) {
                    console.error("Video MediaRecorder initialization failed:", e);
                    setIsFallback(true);
                    startRecording();
                    return;
                }
            }
        }
    }

    async function videoToblobFun() {
        setRecordTime(0);
        if (streamRef.current) {
            const audioStream = new MediaStream();
            streamRef.current.getTracks().forEach(track => {
                if (track.kind === 'audio') audioStream.addTrack(track);
            });

            // Reduce resolution at capture level
            const videoConstraints = {
                width: { ideal: 854 }, // about 480p width
                height: { ideal: 480 },
                frameRate: { ideal: 20 }
            };

            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: videoConstraints,
                audio: true
            });
            streamRef.current = mediaStream;

            let videoChunks = [];
            try {
                const videoRecorder = new MediaRecorder(mediaStream, {
                    mimeType: "video/webm; codecs=vp8,opus",
                    videoBitsPerSecond: 500_000 // lower bitrate (~0.5 Mbps)
                });

                videoRecorder.ondataavailable = (event) => {
                    if (event.data && event.data.size > 0) videoChunks.push(event.data);
                };

                videoRecorder.onstop = async () => {
                    const videoBlob = new Blob(videoChunks, { type: "video/webm" });

                    // Check size
                    // if (videoBlob.size > 5 * 1024 * 1024) {
                    //     alert(`⚠️ Video is still too big: ${(videoBlob.size / 1024 / 1024).toFixed(2)} MB`);
                    // } else {
                    //     alert(`✅ Video size: ${(videoBlob.size / 1024 / 1024).toFixed(2)} MB`);
                    // }

                    if (!isAbortedByFaceDetectionRef.current) {
                        setRecordedBlob(videoBlob);
                    }
                    // sendVideoToApi(videoBlob);
                };

                videoRecorder.start();
                recorderRef.current = videoRecorder;
                setIsRecording(true);

            } catch (e) {
                console.error("Video recording failed:", e);
                setIsFallback(true);
                startRecording();
                return;
            }
        }
    }

    const stopRecording = () => {
        // alert('stop')
        handleRecordedPlayPause()
        if (detectIntervalRef.current) {
            clearInterval(detectIntervalRef.current);
            detectIntervalRef.current = null;
        }
        if (isFallback && recorderRef.current) {
            recorderRef.current.stopRecording(() => {
                const blob = recorderRef.current.getBlob();

                // do NOT preview
                if (!isAbortedByFaceDetectionRef.current) {
                    setRecordedBlob(blob);
                }

                if (videoRef.current) {
                    videoRef.current.pause();
                    videoRef.current.srcObject = null;
                    videoRef.current.removeAttribute('src');
                }

                sendVideoToApi(blob);
            });
        } else if (recorderRef.current) {
            recorderRef.current.stop();
        }
        if (streamRef.current) {
            streamRef.current.getTracks().forEach((track) => track.stop());
        }
        setIsRecording(false);
    };

    // timer
    useEffect(() => {
        let interval;
        if (isRecording && recordTime < maxRecordTime) {
            interval = setInterval(() => setRecordTime((prev) => prev + 1), 1000);
        }
        // console.log('record',recordTime);
        if(recordTime === 3){
           loadModal()
        }
        if (recordTime === maxRecordTime) {
            stopRecording();
        }
        return () => clearInterval(interval);
    }, [isRecording, recordTime]);

    const handleRetake = () => {
        let allowRetry = params['allowRetry'] || 'false';

        if (allowRetry === 'true') {
            let paramsCntId = params['cntid'] || 'test1';
            let paramsKycId = params['kycid'] || 'test1';
            // toast.success('Successfully toasted!')
            const myHeaders = new Headers();
            myHeaders.append("x-api-key", api.x_api_key);
            myHeaders.append("authorizationToken", api.authorizationToken);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "clientid": paramsCntId,
                "kycid": paramsKycId
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch(api.getusercount, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    let data = {
                        ...result,
                        "result": false,
                        "api_status": 0,
                        "remark": "user have exhausted all attempts",
                        "transcript": "",
                        "request_id": "",
                        "client_id": result.client_id || paramsCntId,
                        "kyc_id": paramsKycId,
                    };

                    if (result.count == 0) {
                        toast(`3 ${declarationTextFallback.attemptsRemaining[language]}`,
                            {
                                icon: '✅',
                                style: {
                                    borderRadius: '10px',
                                    background: '#333',
                                    color: '#fff',

                                },
                            }
                        );
                        // clear previous result + blob
                        setRecordedBlob(null);
                        setRecordTime(0);
                        setApiTranscript("");
                        setFaceOutofCircle(0);
                        handleCaptureClick();
                        setIsVideoComponentVisible(true);
                    } else if (result.count < 3) {
                        toast(`${3 - result.count} ${declarationTextFallback.attemptsRemaining[language]}`,
                            {
                                icon: '✅',
                                style: {
                                    borderRadius: '10px',
                                    background: '#333',
                                    color: '#fff',

                                },
                            }
                        );
                        // clear previous result + blob
                        setRecordedBlob(null);
                        setRecordTime(0);
                        setApiTranscript("");
                        setFaceOutofCircle(0);
                        handleCaptureClick();
                        setIsVideoComponentVisible(true);
                    } else {
                        toast(`${declarationTextFallback.allAttemptsUsed[language]}`,
                            {
                                icon: '❌',
                                style: {
                                    borderRadius: '10px',
                                    background: '#333',
                                    color: '#fff',

                                },
                            }
                        );
                        // console.log('data', data)
                        window.parent.postMessage(data, "*");
                    }

                })
                .catch((error) => console.error(error));
        } else {
            setRecordedBlob(null);
            setRecordTime(0);
            setApiTranscript("");
            setFaceOutofCircle(0);
            handleCaptureClick();
            setIsVideoComponentVisible(true);
        }

    };

    const handleRetake1 = () => {
        setRecordedBlob(null);
        setRecordTime(0);
        setApiTranscript("");
        setFaceOutofCircle(0);
        setTransScriptStatus(false);
        setIllustrations(true);
        handleCaptureClick();
        setIsVideoComponentVisible(true);
        setTimeout(() => {
            handleRetake();
        }, 500);
    };

    const handleSubmitVideo = async () => {
        if (!recordedBlob) {
            console.error("No recorded blob found.");
            return;
        }
        setVideoLoaded(true);
        setIsApiLoading(true);
        setSubmitLoading(true);
        const requestId = `file_${uniqueId}`;

        try {
            const presignedUrlResponse = await fetch(
                `https://kl0igqgz8f.execute-api.ap-south-1.amazonaws.com/default/presignedurl?request_id=${requestId}&client_id=123_ketan`,
                {
                    method: "POST",
                    headers: { "x-api-key": "67DKlH24PiKwYdTxHzy7Ou4XBuEz7g5ZV9rkW500" },
                }
            );

            const presignedUrlData = await presignedUrlResponse.json();
            if (!presignedUrlData.upload_url) {
                console.error("Failed to get upload URL");
                setIsApiLoading(false);
                setSubmitLoading(false);
                return;
            }

            const uploadUrl = presignedUrlData.upload_url;

            const uploadResponse = await fetch(uploadUrl, {
                method: "PUT",
                body: recordedBlob,
                headers: {
                    "Content-Type": recordedBlob.type || "video/webm",
                },
            });

            if (uploadResponse.ok) {
                setSubmitSuccess(true)
                // setSuccess(true);
                setSubmitLoading(false);
            } else {
                console.error("Error uploading video:", uploadResponse);
            }
        } catch (error) {
            console.error("Error in handleSubmitVideo:", error);
        }
        setIsApiLoading(false);
    };

    const handleTimeUpdate = () => { };

    const handleSubmitVideoFinal = async () => {
        if (isSubmitting) return; // guard against multiple clicks
        if (!recordedBlob) {
            console.error("No recorded blob found.");
            return;
        }
        setIsSubmitting(true);
        try {
            console.log("Submitting video blob of size:");
            await sendVideoToApi(recordedBlob);
        } catch (err) {
            console.error("submit error:", err);
        } finally {
            // keep button disabled while API is processing; re-enable after short delay or based on your flow
            setTimeout(() => setIsSubmitting(false), 2000);
        }
    }

    // console.log('isVideoComponentVisible', isVideoComponentVisible);
    if (submitSuccess) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                gap: '8px',
                padding: '8px',
                backgroundColor: '#d4edda',
                color: '#155724',
                borderRadius: '5px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                width: '20rem'
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                <span style={{ fontSize: '14px', fontWeight: '500' }}>{declarationTextFallback.inPersonVerification[language]}</span>
            </div>
        )
    }

    return (
        <div
            style={{
                // height: "100vh",
                width: "100vw",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div><Toaster /></div>
            <div className="video-recorder-container">
                <div className="video-recorder-main ">
                    <div className="video-recorder-top-bar">
                        <img src={applogo} className="App-logo" alt="logo" />
                        <select
                            value={language}
                            // onChange={(e) => setLanguage(e.target.value)}
                            onChange={(e) => {
                                const lang = e.target.value;
                                setLanguage(lang);
                                setRecordedBlob(null); setRecordedUrl("");
                                // handleRetake(); // restart/retake when language changes
                            }}
                            className="language-select"
                        >
                            <option value="en">English</option>
                            <option value="hi">हिन्दी</option>
                            <option value="gu">ગુજરાતી</option>
                            <option value="mr">मराठी</option>
                            <option value="ta">தமிழ்</option>
                            <option value="te">తెలుగు</option>
                            <option value="kn">ಕನ್ನಡ</option>
                            <option value="ml">മലയാളം</option>
                            <option value="bn">বাংলা</option>
                            {/* <option value="od">ଓଡ଼ିଆ</option> */}
                        </select>
                    </div>
                    {
                        authorized ?
                            <>
                                {(faceOutofCircle < 120 || recordedUrl) ? (
                                    <>
                                        <h2 className="video-recorder-heading">{declarationTextFallback.nominationOptOutRequest[language]}</h2>
                                        <div>
                                            <p className="video-recorder-declaration">{declarationTextFallback.pleaseReadDeclaration[language]}</p>
                                            {language !== "" && (
                                                <p className="video-recorder-declaration-text">
                                                    {declarationTextFallback.nominationOptOutSentence[language]}
                                                </p>
                                            )}
                                        </div>
                                        <div className="video-recorder-video-container">
                                            {isCountingDown && (
                                                <div>
                                                    <div className="video-recorder-countdown">{countdown}</div>
                                                </div>
                                            )}

                                            {isRecording && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: '10%',
                                                        width: '98%',
                                                        display: 'flex',
                                                        justifyContent: 'end',
                                                        zIndex: 999
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            backgroundColor: 'rgba(222, 217, 217, 0.87)',
                                                            padding: 5,
                                                            borderRadius: '10px',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        00:{formatTime(recordTime)} / 00:{formatTime(maxRecordTime)}
                                                    </span>
                                                </div>
                                            )}

                                            {/* Live preview only (never plays the recorded video) */}
                                            {/* {
                                    isVideoComponentVisible ? <>
                                        <video
                                            ref={videoRef}
                                            autoPlay
                                            onTimeUpdate={handleTimeUpdate}
                                            className="video-recorder-video"
                                            style={{
                                                width: '310px',
                                                height: '300px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                transform: 'scaleX(-1)',
                                                marginBottom: '60px',
                                                gap: '30px',
                                            }} />
                                    </>
                                        : < div>
                                            <h3 style={{ color: 'red' }}>*{apiTranscript}</h3>
                                            <p style={{ color: 'black', textAlign: 'center' }}>Please click on retake button to start again</p>
                                        </div>
                                } */}

                                            {
                                                recordedUrl ? (
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '300px', }}>
                                                        {
                                                            isVideoComponentVisible ? <>
                                                                <video
                                                                    ref={playbackRef}
                                                                    src={recordedUrl}
                                                                    controls={false}
                                                                    onLoadedMetadata={onRecordedLoaded}
                                                                    onTimeUpdate={onRecordedTimeUpdate}
                                                                    onPlay={() => setIsRecordedPlaying(true)}
                                                                    onPause={() => setIsRecordedPlaying(false)}
                                                                    disablePictureInPicture
                                                                    style={{
                                                                        width: '310px',
                                                                        height: '210px',
                                                                        borderRadius: '16px',
                                                                        objectFit: 'contain',
                                                                        marginBottom: '12px',

                                                                    }}

                                                                />
                                                                {
                                                                    isIos ? <>
                                                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                                                            <button onClick={handleRecordedPlayPause} style={{ padding: '4px 12px', marginTop: '1px' }}>
                                                                                {isRecordedPlaying ? "Pause" : "Play"}
                                                                            </button>
                                                                        </div>
                                                                    </> : <> <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                                                        <span onClick={handleRecordedPlayPause} style={{ padding: '4px 12px', marginTop: '1px' }}>
                                                                            {isRecordedPlaying ? <FaPause /> : <FaPlay />}
                                                                        </span>
                                                                        <input
                                                                            type="range"
                                                                            min={0}
                                                                            max={recordedDuration || 0}
                                                                            step="0.1"
                                                                            value={recordedCurrentTime || 0}
                                                                            onChange={handleRecordedSeekChange}
                                                                            style={{ width: 200, height: '4px' }}
                                                                        />
                                                                        <div style={{ minWidth: 90, textAlign: 'center' }}>
                                                                            00:{formatTime(Math.floor(recordedCurrentTime || 0))} / 00:{formatTime(Math.floor(recordedDuration || 0))}
                                                                        </div>
                                                                    </div></>
                                                                }

                                                                <div style={{ display: 'flex', gap: 8, marginTop: '15px' }}>
                                                                    <button
                                                                        onClick={() => { setRecordedBlob(null); setRecordedUrl(""); handleRetake(); }}
                                                                        style={{
                                                                            // width: '10rem',
                                                                            height: '40px',
                                                                            border: "1.5px solid #a3cef1",
                                                                            backgroundColor: "#e7e4ff",
                                                                            borderRadius: "10px",
                                                                            cursor: "pointer",
                                                                            fontSize: "16px",
                                                                        }}
                                                                    >
                                                                        {declarationTextFallback.retake[language]}
                                                                    </button>
                                                                    <button onClick={handleSubmitVideoFinal} style={{
                                                                        // width: '7rem',
                                                                        height: '40px',
                                                                        border: "1.5px solid #a3cef1",
                                                                        backgroundColor: "#e7e4ff",
                                                                        borderRadius: "10px",
                                                                        cursor: "pointer",
                                                                        fontSize: "16px",
                                                                    }}>
                                                                        {declarationTextFallback.submitVideo[language]}
                                                                    </button>
                                                                </div>
                                                            </> :
                                                                <>
                                                                    <div style={{ height: '300px' }}>
                                                                        <h3 style={{ color: 'red', textAlign: 'center' }}>*{apiTranscript}</h3>
                                                                        {/* <p style={{ color: 'black', textAlign: 'center' }}>{declarationTextFallback.inPersonVerificationFailed[language]}</p> */}
                                                                        <div style={{
                                                                            padding: '8px',
                                                                            backgroundColor: '#ebf4f8ff',
                                                                            color: '#131313ff',
                                                                            borderRadius: '5px',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

                                                                        }}>
                                                                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg> */}
                                                                            <span style={{ fontSize: '14px', fontWeight: '500' }}>{declarationTextFallback.inPersonVerificationFailed[language]}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ display: 'flex', gap: 8 }}>
                                                                        <button
                                                                            // onClick={handleRetake}
                                                                            onClick={() => { setRecordedBlob(null); setRecordedUrl(""); handleRetake(); }}
                                                                            style={{
                                                                                // width: '10rem',
                                                                                height: '40px',
                                                                                border: "1.5px solid #a3cef1",
                                                                                backgroundColor: "#e7e4ff",
                                                                                borderRadius: "10px",
                                                                                cursor: "pointer",
                                                                                fontSize: "16px",
                                                                            }}
                                                                        >
                                                                            {declarationTextFallback.retake[language]}
                                                                        </button>
                                                                    </div>
                                                                </>
                                                        }
                                                    </div>
                                                ) : isVideoComponentVisible ? (
                                                    <>
                                                        <video
                                                            ref={videoRef}
                                                            autoPlay
                                                            onTimeUpdate={handleTimeUpdate}
                                                            disablePictureInPicture
                                                            className="video-recorder-video"
                                                            style={{
                                                                width: '13rem',
                                                                height: '13rem',
                                                                borderRadius: '50%',
                                                                objectFit: 'cover',
                                                                transform: 'scaleX(-1)',
                                                                marginBottom: '60px',
                                                                gap: '30px',
                                                            }}
                                                        />
                                                    </>
                                                ) : (
                                                    <div>
                                                        <h3 style={{ color: 'red' }}>*{apiTranscript}</h3>
                                                        {/* <p style={{ color: 'black', textAlign: 'center' }}>{declarationTextFallback.inPersonVerificationFailed[language]}</p> */}
                                                        <div style={{
                                                            padding: '8px',
                                                            backgroundColor: '#ebf4f8ff',
                                                            color: '#131313ff',
                                                            borderRadius: '5px',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

                                                        }}>
                                                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg> */}
                                                            <span style={{ fontSize: '12px', fontWeight: '500' }}>{declarationTextFallback.inPersonVerificationFailed[language]}</span>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {illustrations && (
                                                <>
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: '40%',
                                                            width: '98%',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            paddingBottom: '20px',
                                                            zIndex: 10000  // Add this to parent
                                                        }}
                                                    >
                                                        <MyIcon width={150} height={150} />
                                                        <img src={arrow} width={50} height={50} style={{ animation: "bounce 2s infinite", zIndex: 9999, position: 'relative' }} alt="" />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: '30%',
                                                            width: '98%',
                                                            display: 'flex',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                backgroundColor: 'rgba(222, 217, 217, 0.87)',
                                                                padding: 8,
                                                                borderRadius: '10px',
                                                                textAlign: 'center',
                                                                fontSize: '13px',
                                                            }}
                                                        >
                                                            {declarationTextFallback.pleaseSelectLanguage[language]}
                                                        </span>
                                                    </div>
                                                </>
                                            )}

                                            {isApiLoading && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        bottom: '40%',
                                                        width: '98%',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        zIndex: 999
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            backgroundColor: 'rgba(222, 217, 217, 0.45)',
                                                            padding: 8,
                                                            borderRadius: '10px',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <p className="text-shine">{declarationTextFallback.analyzingVideo[language]}</p>
                                                    </span>
                                                </div>
                                            )}

                                            {language !== "" && !recordedBlob && (
                                                <div className="video-recorder-capture-button-container">
                                                    <button
                                                        onClick={handleCaptureClick}
                                                        style={{
                                                            width: '10rem',
                                                            height: '40px',
                                                            padding: "10px",
                                                            border: "1.5px solid rgb(255, 186, 186)",
                                                            backgroundColor: isRecording ? "rgb(199, 199, 199)" : "rgb(255, 132, 132)",
                                                            borderRadius: "10px",
                                                            cursor: "pointer",
                                                            fontSize: "16px",
                                                            position: "fixed",
                                                            bottom: "0vh", // add extra 50px spacing from video circle
                                                            left: "50%",
                                                            transform: "translateX(-50%)",
                                                            zIndex: 1000,
                                                            maxWidth: "90vw",
                                                        }}
                                                    >
                                                        <span style={{ fontSize: '14px', fontWeight: 'bold', color: "black" }}>
                                                            {isRecording ? `${declarationTextFallback.stopRecordingLan[language]}` : `${declarationTextFallback.startRecordingLan[language]}`}
                                                        </span>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        {apiTranscript.length !== 0 && (
                                            <>
                                                {transScriptStatus ? (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            marginTop: "5px",
                                                        }}
                                                    >
                                                        <button
                                                            onClick={handleRetake}
                                                            style={{
                                                                width: '30%',
                                                                height: '40px',
                                                                border: "1.5px solid #a3cef1",
                                                                backgroundColor: "#e7e4ff",
                                                                borderRadius: "10px",
                                                                cursor: "pointer",
                                                                fontSize: "16px",
                                                            }}
                                                        >
                                                            {declarationTextFallback.retake[language]}
                                                        </button>

                                                        {videoLoaded ? (
                                                            <button className="animated-button">
                                                                <span></span>
                                                                <span></span>
                                                                <span></span>
                                                                <span></span>
                                                                <p className="btn-shine"> Processing...</p>
                                                            </button>
                                                        ) : (
                                                            <button
                                                                onClick={handleSubmitVideo}
                                                                style={{
                                                                    width: '65%',
                                                                    height: '40px',
                                                                    border: "1.5px solid #a3cef1",
                                                                    borderRadius: "10px",
                                                                    cursor: "pointer",
                                                                    fontSize: "16px",
                                                                    backgroundColor: 'rgb(229, 255, 234)',
                                                                    color: 'black'
                                                                }}
                                                            >
                                                                Submit Video
                                                            </button>
                                                        )}
                                                    </div>
                                                ) : (
                                                    // <div
                                                    //     style={{
                                                    //         display: "flex",
                                                    //         justifyContent: "center",
                                                    //         marginTop: "5px",
                                                    //     }}
                                                    // >
                                                    //     <button
                                                    //         // onClick={handleRetake}
                                                    //         onClick={() => { setRecordedBlob(null); setRecordedUrl(""); handleRetake(); }}
                                                    //         style={{
                                                    //             width: '30%',
                                                    //             height: '40px',
                                                    //             border: "1.5px solid #a3cef1",
                                                    //             backgroundColor: "#e7e4ff",
                                                    //             borderRadius: "10px",
                                                    //             cursor: "pointer",
                                                    //             fontSize: "16px",
                                                    //         }}
                                                    //     >
                                                    //         Retake
                                                    //     </button>
                                                    //       <button
                                                    //         onClick={handleSubmitVideoFinal}
                                                    //         style={{
                                                    //             width: '30%',
                                                    //             height: '40px',
                                                    //             border: "1.5px solid #a3cef1",
                                                    //             backgroundColor: "#e7e4ff",
                                                    //             borderRadius: "10px",
                                                    //             cursor: "pointer",
                                                    //             fontSize: "16px",
                                                    //         }}
                                                    //     >
                                                    //         submit
                                                    //     </button>
                                                    // </div>
                                                    <></>
                                                )}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <h2 className="video-recorder-heading">{declarationTextFallback.centerFaceInstruction[language]}</h2>
                                        <div className="video-recorder-video-container">
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '40%',
                                                    width: '98%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    paddingBottom: '20px',
                                                }}
                                            >
                                                <MyIcon width={150} height={150} />
                                            </div>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '15%',
                                                    width: '98%',
                                                    display: 'flex',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        backgroundColor: 'rgba(222, 217, 217, 0.87)',
                                                        padding: 8,
                                                        borderRadius: '10px',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    {declarationTextFallback.keepFaceInstruction[language]}
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginTop: "5px",
                                            }}
                                        >
                                            <button
                                                onClick={handleRetake1}
                                                style={{
                                                    width: '50%',
                                                    height: '40px',
                                                    border: "1.5px solid #a3cef1",
                                                    backgroundColor: "#e7e4ff",
                                                    borderRadius: "10px",
                                                    cursor: "pointer",
                                                    fontSize: "16px",
                                                }}
                                            >
                                                {declarationTextFallback.retake[language]}
                                            </button>
                                        </div>
                                    </>
                                )}
                            </>
                            :
                            <div className="video-recorder-video-container">
                                <div
                                    style={{
                                        padding: "16px",
                                        backgroundColor: "#fef2f2",
                                        border: "1px solid #fecaca",
                                        borderRadius: "12px",
                                        maxWidth: "380px",
                                        fontFamily: "Arial, sans-serif"
                                    }}
                                >
                                    <h2
                                        style={{
                                            fontSize: "22px",
                                            marginBottom: "8px",
                                            color: "#d32f2f",
                                            fontWeight: "600"
                                        }}
                                    >
                                        Not Authorized
                                    </h2>

                                    <p
                                        style={{
                                            fontSize: "14px",
                                            color: "#444",
                                            marginBottom: "6px"
                                        }}
                                    >
                                        You don't have permission to access this feature. It looks like your account
                                        does not have the required privileges.
                                    </p>

                                    <p
                                        style={{
                                            fontSize: "12px",
                                            color: "#666"
                                        }}
                                    >
                                        If you believe this is a mistake, please contact your administrator or check
                                        your account settings.
                                    </p>
                                </div>

                            </div>
                    }
                    <p style={{ textAlign: 'center' }}>Powered by AiNxt</p>
                </div>

                <style>
                    {`
                    @keyframes blink {
                        0% { opacity: 1; }
                        50% { opacity: 0.2; }
                        100% { opacity: 1; }
                    }
                    @keyframes bounce {
                        0%, 100% { transform: translateY(10); }
                        50% { transform: translateY(-20px); }
                    }
                 `}
                </style>
            </div>
        </div>
    );
};

export default VideoComponent;

